/** Home data: GET /api/home (facts, fleet status, the briefing) for the top bar's scope. */
import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api, unwrap } from '@/lib/api/client';

export const homeKeys = {
  all: ['home'] as const,
  home: (projects: string[] | undefined) => ['home', projects ?? []] as const,
};

/** Today's facts and briefing; re-read every five minutes (the counts move, the briefing is cached per day). */
export function useHome(projects: string[] | undefined) {
  return useQuery({
    queryKey: homeKeys.home(projects),
    queryFn: () => unwrap(api.GET('/api/home', { params: { query: { project: projects } } })),
    placeholderData: keepPreviousData,
    refetchInterval: 5 * 60_000,
  });
}

/** Write a new briefing now (the assistant when AI is on, else plain sentences from the facts). */
export function useNewBriefing(projects: string[] | undefined) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => unwrap(api.GET('/api/home', { params: { query: { project: projects, refresh: true } } })),
    onSuccess: (data) => qc.setQueryData(homeKeys.home(projects), data),
  });
}
